(function(angular, module) {var AnnualSurveyReportBaseController, AnnualSurveyReportYearController, ProgramAnnualSurveyReportController, annualSurveyStates, getValidYears, resoveProgramReportData, surveyColumns,
  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

annualSurveyStates = function($stateProvider, TagUrl) {
  'ngInject';
  var url;
  url = new TagUrl().addTagTypes(['program', 'location']).setTagDefault('affiliation', 'all');
  $stateProvider.state('reports.annualSurvey', {
    url: url.buildUrl('/annual-survey'),
    params: url.params,
    data: {
      tagUrl: url
    },
    reloadOnSearch: false,
    templateUrl: 'reports/annualSurveyBase',
    controller: 'AnnualSurveyReportBaseController',
    controllerAs: '$ctrl'
  });
  $stateProvider.state('reports.annualSurvey.year', {
    url: '/:year?{page:int}{sort}',
    params: {
      page: {
        value: 1,
        squash: true
      },
      sort: {
        value: 'name',
        squash: true
      }
    },
    reloadOnSearch: false,
    templateUrl: 'reports/annualSurveyYear',
    controller: 'AnnualSurveyReportYearController',
    controllerAs: '$ctrl'
  });
  return $stateProvider.state('program.reports.annualSurvey', {
    url: '/annual-survey',
    templateUrl: 'reports/programAnnualSurvey',
    controller: 'ProgramAnnualSurveyReportController',
    controllerAs: '$ctrl',
    resolve: {
      surveys: resoveProgramReportData
    }
  });
};

resoveProgramReportData = function($http, ApiUrl, program) {
  'ngInject';
  var url;
  url = ApiUrl('reports', 'annual_survey', 'program', program.id);
  return $http.get(url).then(function(data) {
    return data.data.items;
  });
};

getValidYears = function() {
  var date, end, i, results, year;
  date = new Date();
  year = date.getFullYear();
  end = date.getMonth() >= 9 ? year : year - 1;
  return (function() {
    results = [];
    for (var i = end; end <= 2015 ? i <= 2015 : i >= 2015; end <= 2015 ? i++ : i--){ results.push(i); }
    return results;
  }).apply(this);
};

surveyColumns = ['applicants', 'started_mental_toughness', 'housing_units_completed', 'housing_units_rehabed', 'housing_units_weatherized', 'housing_units_energy_star', 'housing_units_leed', 'housing_units_other_green'];

ProgramAnnualSurveyReportController = (function() {

  /* @ngInject */
  function ProgramAnnualSurveyReportController(surveys) {
    this.surveys = surveys;
    this.columns = surveyColumns;
  }

  return ProgramAnnualSurveyReportController;

})();

AnnualSurveyReportBaseController = (function() {

  /* @ngInject */
  function AnnualSurveyReportBaseController($timeout, $scope, $state, ApiUrl, FileService) {
    this.refresh = bind(this.refresh, this);
    this.scope = $scope;
    this.timeout = $timeout;
    this.FileService = FileService;
    this.ApiUrl = ApiUrl;
    this.years = getValidYears();
    this.scope.refresh = this.refresh.bind(this);
    this.scope.triggerRefresh = this.triggerRefresh.bind(this);
    if ($state.current.name === "reports.annualSurvey") {
      $state.go('.year', {
        year: this.years[0]
      });
    }
  }

  AnnualSurveyReportBaseController.prototype.refresh = function(params) {
    this.timeout.cancel(this.refreshTimeout);
    return this.refreshTimeout = this.timeout(((function(_this) {
      return function() {
        return _this.broadcastRefresh(params);
      };
    })(this)), 10);
  };

  AnnualSurveyReportBaseController.prototype.broadcastRefresh = function(params) {
    this.lastParams = params;
    return this.scope.$broadcast('tagRefresh', params);
  };

  AnnualSurveyReportBaseController.prototype.triggerRefresh = function() {
    if (angular.isDefined(this.lastParams)) {
      return this.refresh(this.lastParams);
    }
  };

  AnnualSurveyReportBaseController.prototype.downloadFile = function() {
    var url;
    url = this.ApiUrl('reports', 'annual_survey', 'export.xlsx');
    this.downloading = true;
    return this.FileService.downloadFile(url, this.lastParams).then((function(_this) {
      return function() {
        return _this.downloading = false;
      };
    })(this));
  };

  return AnnualSurveyReportBaseController;

})();

AnnualSurveyReportYearController = (function() {

  /* @ngInject */
  function AnnualSurveyReportYearController($scope, $http, $timeout, $stateParams, $state, ApiUrl) {
    this.onSortChange = bind(this.onSortChange, this);
    this.onTagRefresh = bind(this.onTagRefresh, this);
    this.queueLoad = bind(this.queueLoad, this);
    this.scope = $scope;
    this.http = $http;
    this.timeout = $timeout;
    this.state = $state;
    this.ApiUrl = ApiUrl;
    this.columns = surveyColumns;
    this.loading = false;
    this.sort = $stateParams.sort;
    this.page = $stateParams.page;
    this.year = $stateParams.year;
    this.scope.$on('tagRefresh', this.onTagRefresh);
    this.scope.$watch(((function(_this) {
      return function() {
        return _this.page;
      };
    })(this)), this.queueLoad);
    this.scope.triggerRefresh();
  }

  AnnualSurveyReportYearController.prototype.queueLoad = function() {
    this.timeout.cancel(this.queueTimeout);
    return this.timeout(((function(_this) {
      return function() {
        return _this.loadData();
      };
    })(this)), 10);
  };

  AnnualSurveyReportYearController.prototype.loadData = function() {
    var params, url;
    url = this.ApiUrl('reports', 'annual_survey', 'year', this.year);
    this.loading = true;
    if (!this.tags) {
      return;
    }
    params = angular.extend({}, this.tags, {
      sort: this.sort,
      page: this.page
    });
    this.state.go('.', params, {
      location: 'replace'
    });
    return this.http.get(url, {
      params: params
    }).then((function(_this) {
      return function(result) {
        _this.loading = false;
        _this.data = result.data.items;
        return _this.pager = result.data.pager;
      };
    })(this));
  };

  AnnualSurveyReportYearController.prototype.onTagRefresh = function(event, tags) {
    if (!angular.equals(this.tags, tags)) {
      if (!this.tags) {
        this.page = 1;
      }
      this.tags = tags;
      return this.queueLoad();
    }
  };

  AnnualSurveyReportYearController.prototype.onSortChange = function() {
    this.page = 1;
    return this.queueLoad();
  };

  return AnnualSurveyReportYearController;

})();

module.config(annualSurveyStates);

module.controller('ProgramAnnualSurveyReportController', ProgramAnnualSurveyReportController);

module.controller('AnnualSurveyReportBaseController', AnnualSurveyReportBaseController);

module.controller('AnnualSurveyReportYearController', AnnualSurveyReportYearController);
})(angular, angular.module("dybReports"));